import { Link } from 'react-router-dom';
import { MessageCircle, Ticket } from 'lucide-react';

export default function MobileCTA() {
  const handleChatClick = () => {
    // Always use loadAndOpenKeplero to ensure widget is loaded
    if (window.loadAndOpenKeplero) {
      window.loadAndOpenKeplero();
    }
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden glass border-t border-stone-200"
      data-testid="mobile-cta"
    >
      <div className="flex">
        <button
          onClick={handleChatClick}
          className="flex-1 flex items-center justify-center gap-2 py-4 text-night hover:bg-stone-100 transition-colors border-r border-stone-200"
          data-testid="mobile-cta-chat"
        >
          <MessageCircle size={20} strokeWidth={1.5} />
          <span className="font-body text-sm uppercase tracking-wider">Chat</span>
        </button>
        <Link
          to="/night-events"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-night text-ivory hover:bg-stone-800 transition-colors"
          data-testid="mobile-cta-tickets"
        >
          <Ticket size={20} strokeWidth={1.5} />
          <span className="font-body text-sm uppercase tracking-wider">Biglietti</span>
        </Link>
      </div>
    </div>
  );
}
